import InviteMember from 'pages/projects/kanban/shared/InviteMember/InviteMember';
import React, { useState, useRef } from 'react';
import { Popover } from 'react-tiny-popover';
import PLUS_BUTTON_ICON from 'assets/img/plus-button.svg';
import AvatarGroup from '../../shared/AvatarGroup';
import UserIcon from 'assets/img/user3.svg';
import Avatar from '../../shared/Avatar';
import style from './Tasks.module.css';

const AssignSelection = ({
  members,
  handleMember,
  assignees,
  handleRemove,
  showAddIcon = true,
  renderTop = false,
  isMilestoneBoard = false,
  disabled = false,
  showRemove = false,
  popoverRef,
  isFromModal = false
}) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const [positions, setPositions] = useState(['bottom', 'top']);

  const handleOpen = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 350 && spaceAbove > spaceBelow) {
      setPositions(['top', 'bottom']); // open upward
    } else {
      setPositions(['bottom', 'top']); // open downward
    }

    setOpen(true);
  };
  return (
    <div ref={triggerRef}>
      <Popover
        isOpen={open}
        positions={positions}
        padding={8}
        parentElement={document.body} // ✅ real portal — escapes scroll container
        reposition={true}
        onClickOutside={() => setOpen(false)}
        content={
          <div
            ref={popoverRef}
            className={style.assignPopover}
            style={{
              width: 350,
              zIndex: 999999
            }}
            onClick={(e) => e.stopPropagation()}>
            <InviteMember
              members={members}
              handleMember={handleMember}
              assignees={assignees}
              handleRemove={handleRemove}
              onClose={() => setOpen(false)}
            />
          </div>
        }>
        <div
          // ref={triggerRef}
          className={`d-flex align-items-center gap-1 asign-member cursor_pointer user-group-2 ${
            isMilestoneBoard ? 'ml-0' : ''
          } ${assignees?.length == 0 ? 'min75' : ''}`}
          onClick={() => {
            if (!disabled) {
              handleOpen();
              setOpen(true);
            }
          }}>
          {isMilestoneBoard && (
            <>
              <img src={UserIcon} alt="UserIcon-icon" className="UserIcon" />
              {!assignees?.length && <p>Add member</p>}
            </>
          )}

          {assignees?.length > 0 && (
            <AvatarGroup
              size={isMilestoneBoard ? 25 : isFromModal ? 25 : 34}
              members={assignees}
              membersList={members}
              showAddIcon={showAddIcon}
              showRemove={showRemove}
              handleRemove={handleRemove}
            />
          )}

          {!isMilestoneBoard && (
            <Avatar size={'extraSmall'}>
              <img src={PLUS_BUTTON_ICON} alt="plus-button-icon" className={style.hover_controls} />
            </Avatar>
          )}
        </div>
      </Popover>
    </div>
  );
};

export default AssignSelection;
